import React, { PropsWithChildren, useCallback } from 'react';
import { isNativePlatform } from '../../utils/platform';

const OutboundLink = (
  props: PropsWithChildren<{
    className?: string;
    style?: React.CSSProperties;
    href: string;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  }>
) => {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      props.onClick?.(e);
      if (isNativePlatform()) {
        e.preventDefault();
        import('@capacitor/browser')
          .then(({ Browser }) => Browser.open({ url: props.href }))
          .catch(() => {
            window.open(props.href, '_blank');
          });
      }
    },
    [props.href, props.onClick]
  );

  return (
    <a {...props} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
      {props.children}
    </a>
  );
};

export default OutboundLink;
